import React, { memo, useCallback, useEffect } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import { FormProvider, useForm, useWatch } from 'react-hook-form';
import { Button } from '@material-ui/core';
import loopSmileDesignQuestions from './LoopSmileDesignQuestions';
import { useDispatch, useSelector } from 'react-redux';
import {
    setHandleValidateSmileDesignPrescriptionNotes,
    setGetSmileDesignPrescriptionFormValues,
    setSmileDesignPrescriptionFormData,
    setSmileDesignPrescriptionFormIsValid,
} from '../../store/SmileDesign/SmileDesignSlice';
import { useLang } from '../../util/lang';
import useSmileDesignConfig from '../../hooks/useSmileDesignConfig';

// Renders the New Patient ISD Prescription form.
const SmileDesignPrescriptionNotes = ({ key = '', schema, isUpSellTab, isMarieGroup, isTWGroup, isSEAGroup }) => {
    const methods = useForm({
        resolver: yupResolver(schema),
        mode: 'onChange',
    });
    const get = useLang();
    const formValues = useWatch({ control: methods.control });
    const { config } = useSmileDesignConfig({ formValues, isMarieGroup, isTWGroup, isSEAGroup, isUpSellTab });

    const dispatch = useDispatch();
    const displayFirstFitFlag = useSelector((state) => state.globalReducer.displayFirstFitFlag);
    const verticalDimensionQuestion = displayFirstFitFlag ? config[3] : config[3];
    const onSubmit = useCallback((data) => {
        let submitData = { ...data }; //Purpose: avoid readonly object
        submitData['isMarieGroup'] = isMarieGroup;
        submitData['isSEAGroup'] = isSEAGroup;

        if (submitData.verticalDimension === verticalDimensionQuestion.option[0].value) {
            submitData['verticalDimensionUpperPosterior'] = null;
            submitData['verticalDimensionLowerPosterior'] = null;
        }

        if (submitData['preRestorativeAlignerSimulation'] === 'option.no') {
            submitData['upgradePreRestorativeAlignerSimulation'] = null;
        }

        // Debug
        // console.log(submitData);

        dispatch(setSmileDesignPrescriptionFormData(submitData));
    }, [dispatch, isMarieGroup, isSEAGroup, verticalDimensionQuestion]);

    useEffect(() => {
        dispatch(setSmileDesignPrescriptionFormIsValid(methods.formState.isValid));
    }, [methods.formState.isValid]);

    useEffect(() => {
        dispatch(setHandleValidateSmileDesignPrescriptionNotes(methods.handleSubmit(onSubmit)));
    }, [dispatch, methods, onSubmit]);

    useEffect(() => {
        // Exposes live form values to workflow navigation without requiring full form validation.
        dispatch(setGetSmileDesignPrescriptionFormValues(methods.getValues));
    }, []);

    useEffect(() => {
        if (formValues?.buccalFacial_teethReduction || formValues?.palatalLingual_teethReduction) {
            // Remarks: after one of the fields is filled, the other field will be optional
            // Remarks: the error message remove if selected one of the field
            methods.trigger();
        }
    }, [formValues.buccalFacial_teethReduction, formValues.palatalLingual_teethReduction]);

    useEffect(() => {
        // Trigger the group validation so its object-level error is rendered.
        methods.trigger('verticalDimensionPosterior');
    }, [
        formValues?.verticalDimension,
        formValues?.verticalDimensionUpperPosterior,
        formValues?.verticalDimensionLowerPosterior,
    ]);

    return (
        <FormProvider {...methods}>
            <div className={displayFirstFitFlag ? "isd-prescription-radio-scope" : undefined}>{loopSmileDesignQuestions(config, formValues, false, get, true, displayFirstFitFlag)}</div>

            {/* Debug */}
            {/* <Button onClick={methods.handleSubmit(onSubmit)} variant='contained'>
        Submit
      </Button> */}

            {/* <Button onClick={() => {methods.reset(); methods.trigger()}}>
        Reset
      </Button> */}
        </FormProvider>
    );
};

export default memo(SmileDesignPrescriptionNotes);
